import React, { useEffect, useRef, useState } from "react";
import Modal from "../Modal";
import { useDispatch } from "react-redux";
import { addToCart, removeFromCart } from "../../store/cartSlice";
import { showCustomToast } from "../../utils/toast";
import { useNavigate } from "react-router-dom";
import ProductInfo from "./ProductInfo";
import AddedItems from "./AddedItems";
import ProductVariants from "./ProductVariants";
import ProductOrderActions from "./ProductOrderActions";
import { Toaster } from "react-hot-toast";

export default function ProductOrderModal({ open, onClose, product }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const addedItemsRef = useRef(null);

  const [addedItems, setAddItems] = useState([]);
  const [selected, setSelected] = useState(() => {
    const initial = {};
    product.variants.forEach((v) => {
      initial[v.weight] = "";
    });
    return initial;
  });

  useEffect(() => {
    if (addedItems.length > 0) {
      addedItemsRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }
  }, [addedItems]);

  // تبدیل فارسی به انگلیسی
  const toEnglishDigits = (str) => {
    return str.replace(/[۰-۹]/g, (d) =>
      String.fromCharCode(d.charCodeAt(0) - 1728)
    );
  };

  const handleQuantityChange = (weight, value) => {
    const englishValue = toEnglishDigits(value);

    if (englishValue === "") {
      setSelected((prev) => ({
        ...prev,
        [weight]: "",
      }));
      return;
    }

    if (/^\d+$/.test(englishValue)) {
      const normalizedValue = englishValue.replace(/^0+/, "") || "0";
      setSelected((prev) => ({
        ...prev,
        [weight]: normalizedValue,
      }));
    }
  };

  const resetSelected = () => {
    const initial = {};

    product.variants.forEach((v) => {
      initial[v.weight] = "";
    });

    setSelected(initial);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && hasSelectedQuantity) {
      e.preventDefault();
      handleAddToCart();
    }
  };

  const handleAddToCart = () => {
    const newItems = [];

    // بررسی حداقل وزن برای آسیاب
    const powderQuantity = Number(selected["Powder"]);

    if (
      selected["Powder"] !== "" &&
      powderQuantity > 0 &&
      powderQuantity < 100
    ) {
      showCustomToast("حداقل مقدار قهوه آسیاب‌شده ۱۰۰ گرم است.");
      return;
    }

    Object.entries(selected).forEach(([weight, qty]) => {
      const quantity = parseInt(qty);
      if (quantity > 0) {
        const variant = product.variants.find((v) => v.weight === weight);

        const items = {
          id: `${product.id}-${weight}`,
          title: product.title,
          price: variant.price,
          weight: variant.label,
          quantity,
          image: product.images[0],
        }
        dispatch(
          addToCart(items)
        );
        newItems.push(items)
      }
    });
    if (newItems.length > 0) {
      setAddItems((prev) => {
        const updated = [...prev];

        newItems.forEach((newItem) => {
          const existingIndex = updated.findIndex(
            (item) => item.id === newItem.id
          );

          if (existingIndex !== -1) {
            updated[existingIndex] = {
              ...updated[existingIndex],
              quantity:
                updated[existingIndex].quantity + newItem.quantity,
            };
          } else {
            updated.push(newItem);
          }
        });

        return updated;
      });
    }
    resetSelected();
  };

  const handleRemoveItem = (itemId, weight) => {
    setAddItems((prev) =>
      prev.filter((item) => !(item.id === itemId && item.weight === weight))
    );
    dispatch(
      removeFromCart({
        id: itemId,
        weight: weight,
      })
    );
  };
  const hasSelectedQuantity = Object.values(selected).some(
    (value) => Number(value) > 0
  );

  const hasAddedItems = addedItems.length > 0;
  return (
    <>
     <Toaster
      position="top-left"
      reverseOrder={false}
    />
    <Modal
      open={open}
      onClose={onClose}
      title={`جزئیات ${product.title}`}
      maxWidth="sm"
      fullWidth
      actions={
        <ProductOrderActions
          onAdd={handleAddToCart}
          hasSelectedQuantity={hasSelectedQuantity}
          hasAddedItems={hasAddedItems}
          onClose={onClose}
          onGoToCart={() => {
            handleAddToCart();
            onClose();
            navigate("/cart");
          }}
        />
      }
    >
      <div onKeyDown={handleKeyDown}>
        <ProductInfo product={product} />

        <ProductVariants
          product={product}
          selected={selected}
          onQuantityChange={handleQuantityChange}
        />

        <AddedItems
          items={addedItems}
          containerRef={addedItemsRef}
          onRemove={handleRemoveItem}
        />
      </div>
    </Modal>
    </>
  );
}